import * as React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import AdapterJalali from '@date-io/date-fns-jalali';
//import AdapterJalali from '@date-io/jalaali';
import { Button, DialogActions, TextField } from '@mui/material';
import { PickersActionBarProps } from '@mui/x-date-pickers/PickersActionBar';
// import moment from 'moment-jalaali';

import moment from 'moment';

export interface IJalaliDatePickerProps {
    fullWidth?: boolean,
    label?: string,
    error?: boolean,
    helperText?: any,
    onChange: any,
    value?: any,
    name: string,
    disabled?: boolean,
    readOnly?: boolean,
    //disabledOpenPicker?: boolean,
    mode: "date" | "dateTime" | "time",
    disablePast?: boolean
}

const JalaliDatePicker = (props: IJalaliDatePickerProps) => {
    const {
        fullWidth,
        label,
        error,
        helperText,
        onChange,
        name,
        value,
        disabled,
        readOnly,
        mode,
        disablePast
    } = props;
    
    const MyActionBar = ({
        onAccept,
        onSetToday,
    }: PickersActionBarProps) => {
        return (
            <DialogActions style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button variant='contained' onClick={onSetToday}> اكنون </Button>
                <Button onClick={onAccept}>  تاييد </Button>
            </DialogActions>
        );
    };

    return (        
        <LocalizationProvider dateAdapter={AdapterJalali} dateFormats={{ monthShort: 'MMMM' }}>
            { mode == "dateTime" &&  
            <DateTimePicker
                label={label}
                views={['year', 'month', 'day', 'hours', 'minutes']}
                value={value ? moment(value, 'YYYY-MM-DDTHH:mm:ss').toDate() : null}
                ampm={false}
                onChange={(newValue) => {
                        onChange( moment(newValue).isValid() ? moment(newValue).format('YYYY-MM-DDTHH:mm:ss') : undefined)
                    }
                }
                disableOpenPicker={disabled || readOnly}
                disablePast={disablePast}
                renderInput={(params) => <TextField  {...params}  disabled={disabled} id={name} value={value} name={name} fullWidth={fullWidth} error={error} helperText={helperText}
                />}
                components={{
                    ActionBar: MyActionBar
                }}
             />
            }
            { mode == "date" &&
                <DatePicker 
                    views={['year', 'month', 'day']}
                    disabled={disabled}
                    label={label}
                    //mask="____/__/__"
                    components={{
                        ActionBar: MyActionBar
                    }}
                    
                    disableOpenPicker={disabled || readOnly} 
                    value={value ? moment(value, 'YYYY-MM-DDTHH:mm:ss').toDate() : null }
                    renderInput={(params) => <TextField inputProps={{ readOnly: readOnly}} disabled={disabled} id={name} value={value} name={name} fullWidth={fullWidth} {...params} error={error} helperText={helperText} />}
                    onChange={(val) => {
                        onChange( moment(val).isValid() ? moment(val).format('YYYY-MM-DDTHH:mm:ss') : undefined)
                    }}
                />
            }
            { mode == "time" &&
                <TimePicker
                    label={label}
                    value={value}
                    disableOpenPicker={disabled || readOnly}
                    renderInput={(params) => <TextField inputProps={{ readOnly: readOnly}} {...params} disabled={disabled} id={name} value={value} name={name} fullWidth={fullWidth} error={error} helperText={helperText}/>}
                    components={{
                        ActionBar: MyActionBar
                    }}
                    
                    ampm={false}
                    onChange={val => onChange(val)}
                />
            }
        </LocalizationProvider>
    )
}
export default JalaliDatePicker